import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e741542c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e741542c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e741542c')) {
      api.createRecord('e741542c', component.options)
    } else {
      api.reload('e741542c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e741542c&scoped=true&", function () {
      api.rerender('e741542c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ucUNClvcoYqO/JS/comp/Accordion.vue"
export default component.exports